import React from 'react'
import { Box, Typography } from '@mui/material'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'

interface ArrowListItemProps {
  text: string
}

const ArrowListItem: React.FC<ArrowListItemProps> = ({ text }) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <ArrowRightIcon sx={{ color: '#7C7C7C', mr: 1 }} />
      <Typography variant='body1' sx={{ color: '#7C7C7C' }}>
        {text}
      </Typography>
    </Box>
  )
}

export default ArrowListItem
